import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { DeviceService } from '../services';

export const httpDeviceInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return next(req);
  }

  const deviceService = inject(DeviceService);

  req = req.clone({
    setHeaders: {
      'X-Device-ID': deviceService.deviceId(),
      'X-Device-Name': navigator.userAgent,
    },
  });

  return next(req);
};
